module.exports = __webpack_public_path__ + "img/type2_check.bb247113.png";